import React from "react";

export const Mail = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1591_28710)">
      <path
        d="M6 9.60004L12 12.6L18 9.60004"
        stroke="#0D0C1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8 7.20001H7.2C6.53726 7.20001 6 7.73727 6 8.40001V15.6C6 16.2628 6.53726 16.8 7.2 16.8H16.8C17.4627 16.8 18 16.2628 18 15.6V8.40001C18 7.73727 17.4627 7.20001 16.8 7.20001Z"
        stroke="#0D0C1C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1591_28710">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);